import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VehicleCreateBodyWithRegistrationDate, VehicleWithRegistrationDate } from "./vehicle.types";

export const VEHICLE_CREATE_RESOURCE = "vehicle" as const;
export const VEHICLE_CREATE_API_PATH = `/v1/${VEHICLE_CREATE_RESOURCE}` as const;

export type VehicleCreateInput = VehicleCreateBodyWithRegistrationDate;
export type VehicleCreateResponse = VehicleWithRegistrationDate;

export const useVehicleCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<VehicleCreateResponse, Error, VehicleCreateInput>({
    mutationFn: async (data: VehicleCreateInput) => {
      const response = await alphartisApiAxios.post<VehicleCreateResponse>(VEHICLE_CREATE_API_PATH, data);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [VEHICLE_CREATE_RESOURCE],
      });
    },
  });
};
